import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Licence({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header={t("licence")} visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="licensePanel">
            <Trans i18nKey="licenceDetails" />

            <h2 className="text-center titles text-yellow-500">{t("skills")}</h2>

            <p className="text-center"><Trans i18nKey="licenceSkills" /></p>
        </Dialog>
    )
}